module.exports = "<div class=\"container\">\r\n  <br>\r\n  <div class=\"input-group\">\r\n    <label>Comment</label>\r\n    <textarea [(ngModel)]=\"comment\" required></textarea>\r\n  </div>\r\n  <footer>\r\n    <div class=\"container-btn\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"m-btn m-btn-success\"\r\n        title=\"Appeal Claim\"\r\n        (click)=\"saveAction()\"\r\n        [disabled]=\"!comment\"\r\n      >\r\n        Appeal\r\n      </button>\r\n    </div>\r\n  </footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/approval-trip/component/appeal-trip/appeal-trip.component.html
// module id = 2540
// module chunks = 66